import type { MegaMenuItem } from "../types/MegaMenuItem";

export class MenuService {
    public static async getMenuItems(path: string, signal?: AbortSignal) {
        if (typeof AbortSignal.timeout === 'function') {
            const timeout = AbortSignal.timeout(5000);
            if (signal) {
                signal = AbortSignal.any([signal, timeout]);
            }
            else {
                signal = timeout;
            }
        }
        try {
            const response = await fetch(`/api/menu?url=${encodeURIComponent(path)}`, { signal });
            return await response.json() as MegaMenuItem[];
        }
        catch (error) {
            return null;
        }        
    }
}